<template>
  <div>
    <b-row>
      <b-col>
        <div class="card my-0 py-0 border border-primary">
          <div class="card-header bg-transparent border-primary py-0">
            <h5 class="my-0 text-primary">
              <i :class="`fas fa-ticket-alt me-3`"></i>
              {{ $t('Total') }}
            </h5>
          </div>
          <div class="card-body row">
            <div class="summary-column">
              <span class="text-muted small d-block">
                {{ $t('Users') }}
              </span>
              <span class="h5">{{ payment.summary.active_customers_count }}</span>
            </div>

            <div class="summary-column">
              <span class="text-muted small d-block">
                {{ $t('Comissão') }}
              </span>
              <span class="h5">{{ $utils.formatMoneyFloat(payment.summary.reward_accumulative) }}</span>
            </div>

            <div class="summary-column" v-if="!hideCpa">
              <span class="text-muted small d-block"> CPA </span>
              <span class="h5">{{ $utils.formatMoneyFloat(payment.summary.reward_mark) }}</span>
            </div>

            <div class="summary-column">
              <span class="text-muted small d-block">
                {{ $t('Valor a Pagar') }}
              </span>
              <span class="h5">{{ $utils.formatMoneyFloat(payment.summary.reward_total) }}</span>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col class="text-center cursor-pointer" @click="show_details = !show_details">
        {{ $t('Show Details') }}
      </b-col>
    </b-row>
    <div v-if="show_details" class="list-group">
      <b-row class="list-group-item" v-for="(affiliate, i) in payment.data" :key="i">
        <b-col class="">
          <b-row>
            <b-col md="4">
              <b>{{ $t('Nome') }}:</b>&nbsp;{{ affiliate.name }}
            </b-col>
            <b-col md="4">
              <b class="uppercase-text">{{ getDocumentType(affiliate) }}:</b>
              <span class="-nowrap">&nbsp; {{ getDocument(affiliate) }}</span>
            </b-col>
            <b-col md="4">
              <b>{{ $t('Valor a Pagar') }}:</b>
              <span class="-nowrap">&nbsp;{{ $utils.formatMoneyFloat(affiliate.reward_total) }}</span>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
    <hr />
    <div class="row">
      <div class="col-md-6">
        <button :disabled="$store.state.isLoading" class="btn btn-secondary w-100" @click="$emit('hide')">
          {{ $t('Back') }}
        </button>
      </div>
      <div class="col-md-6">
        <button :disabled="$store.state.isLoading" class="btn btn-primary w-100" @click="$emit('confirm')">
          {{ $t('Confirmar') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    payment: {
      type: Object
    }
  },
  emits: ['hide', 'confirm'],
  data() {
    return {
      show_details: false
    };
  },
  computed: {
    hideCpa() {
      this.$store.state.companySettings;
      return this.shouldHideCpa();
    },
    paymentTotal() {
      return this.paymentResume?.total || {};
    },
    paymentData() {
      return this.paymentResume?.dataset || [];
    }
  },
  methods: {
    getDocument(affiliate) {
      return affiliate?.settings?.paymentInfo?.meta?.key || '';
    },
    getDocumentType(affiliate) {
      return affiliate?.settings?.paymentInfo?.meta?.type || '';
    }
  }
};
</script>

<style scoped>
.uppercase-text {
  text-transform: uppercase;
}
</style>
